<div class="range-picker-calendar-wrapper h-100">
  <div class="p-4 w-100 range-picker desktop">
    <div class="d-flex g-4 w-100 pb-4 h-100 range-picker-wrapper">
      <div class="range-picker-calendar">
        <div class="w-100 d-flex justify-content-between w-100 align-items-center">
          <img
            class="cursor-pointer"
            [class.disabled]="!currentIndex"
            (click)="prevMonth()"
            data-id="prev"
            src="assets/icons/keyboard_arrow_left.svg"
            alt="prev"
          />
          <h3 class="bold">{{ months[currentIndex].name }} {{ months[currentIndex].year }}</h3>
          <div></div>
        </div>

        <div>
          <range-picker-calendar
            [days]="months[currentIndex].days"
            (selectDate)="selectDate($event)"
          />
        </div>
      </div>

      <div class="range-picker-calendar">
        <div class="d-flex justify-content-between w-100 align-items-center">
          <div></div>
          <h3 class="bold">
            {{ months[currentIndex + 1].name }} {{ months[currentIndex + 1].year }}
          </h3>
          <img
            class="cursor-pointer"
            [class.disabled]="isNextMonthCurrent()"
            (click)="nextMonth()"
            data-id="prev"
            src="assets/icons/keyboard_arrow_right.svg"
            alt="prev"
          />
        </div>

        <div class="range-picker-calendar">
          <range-picker-calendar
            [days]="months[currentIndex + 1].days"
            (selectDate)="selectDate($event)"
          />
        </div>
      </div>
    </div>
    <div class="d-flex w-100 align-items-end g-3 range-picker-actions">
      <ds-button label="Cancel" variant="secondary" (click)="close.emit()" data-id="cancel" />
      <ds-button
        label="Set dates"
        (click)="setDates.emit(selectedDates)"
        [disabled]="!selectedDates.length"
        data-id="set-dates"
      />
    </div>
  </div>

  <div
    class="d-md-none range-picker w-100 d-flex flex-column align-items-center justify-content-center h-100"
  >
    <div class="h-100 overflow-y range-picker-list">
      @for (month of months; track month.year + month.name) {
        <div data-id="month" class="range-picker-calendar">
          <div class="w-100 d-flex w-100 justify-content-center align-items-center pt-2 pb-2">
            <h3 data-id="month-title" class="bold">{{ month.name }} {{ month.year }}</h3>
          </div>
          <range-picker-calendar [days]="month.days" (selectDate)="selectDate($event)" />
        </div>
      }
    </div>

    <div class="range-picker-calendar-wrapper-action w-100">
      <ds-button
        label="Select date range"
        (click)="setDates.emit(selectedDates)"
        [disabled]="!selectedDates.length"
        [fullWidth]="true"
        data-id="set-dates"
      />
    </div>
  </div>
</div>
